import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { LibHttpUrl } from '../../api/public-api';
import { ResponseBase, Popup } from '../models/base';
import { ServiceBase } from 'src/app/services/service-base';
import { Articledata, ArticledataID, QAList, QAReq, ResponseArticle, ResponseArticleID } from '../models/article';
import { ResponseContact, Responsefeeback } from '../models/activity';
import { ImgToken } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ServiceBase {
  Web$ = new BehaviorSubject<boolean>(true);
  protected baseUrl = `${this.apiBaseUrl}/${LibHttpUrl.User}`;
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  // 取得驗證碼
  GetCaptchaImg(): Observable<ResponseBase<ImgToken>> {
    const url = `${this.baseUrl}/GetCaptchaImg`;
    return this.http.post<ResponseBase<ImgToken>>(
      url,
      this.httpOptions);
  }

  // 發送簡訊驗證碼
  SendSMS(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/SendSMS`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 步驟1驗證
  VerifyStep1(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/VerifyStep1`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 步驟2驗證（身份驗證 - 內政部國民身分證驗證）
  VerifyStep2(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/VerifyStep2`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 步驟3提交
  SubmitStep3(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/SubmitStep3`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 電子帳單申請提交
  SubmitEBillApply(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/SubmitEBillApply`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 取得 ETF 基金代碼列表
  GetETFList(): Observable<ResponseBase<string[]>> {
    const url = `${this.baseUrl}/GetETFList`;
    return this.http.get<ResponseBase<string[]>>(url, this.httpOptions);
  }

  // 取得銀行總機構列表
  GetBankList(): Observable<ResponseBase<Array<{ label: string; value: string }>>> {
    const url = `${this.baseUrl}/GetBankList`;
    return this.http.get<ResponseBase<Array<{ label: string; value: string }>>>(url, this.httpOptions);
  }

  // 依銀行代碼取得分支列表（7碼）
  GetBranchList(bankCode: string): Observable<ResponseBase<Array<{ label: string; value: string }>>> {
    const url = `${this.baseUrl}/GetBranchList?bankCode=${encodeURIComponent(bankCode)}`;
    return this.http.get<ResponseBase<Array<{ label: string; value: string }>>>(url, this.httpOptions);
  }

  // 取得領補換類別清單
  GetApplyCodeList(): Observable<ResponseBase<Array<{ label: string; value: string }>>> {
    const url = `${this.baseUrl}/GetApplyCodeList`;
    return this.http.get<ResponseBase<Array<{ label: string; value: string }>>>(url, this.httpOptions);
  }

  // 取得發證地點清單
  GetIssueSiteList(): Observable<ResponseBase<Array<{ label: string; value: string }>>> {
    const url = `${this.baseUrl}/GetIssueSiteList`;
    return this.http.get<ResponseBase<Array<{ label: string; value: string }>>>(url, this.httpOptions);
  }

  // 步驟3 - 發送 Email 驗證碼
  SendEmailCode(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/SendEmailCode`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }

  // 步驟3 - 驗證 Email 驗證碼
  VerifyEmailCode(request: any): Observable<ResponseBase<any>> {
    const url = `${this.baseUrl}/VerifyEmailCode`;
    return this.http.post<ResponseBase<any>>(url, request, this.httpOptions);
  }
}

